<ion-header><app-navheader></app-navheader></ion-header>
<ion-content padding style="background-color: #ebebeb">
  <ion-item class="header">
    <h1>{{'ACCOUNT.RESET_PARENT_PASSWORD.PASSWORD_LABEL' | translate }}</h1>
  </ion-item>
  <div class="wrapper">
    <form
      (ngSubmit)="onSubmit(resetForm.value, $event)"
      #resetForm="ngForm"
      *ngIf="validToken"
    >
      <ion-item class="firstinput">
        <ion-label stacked
          >{{'ACCOUNT.RESET_PARENT_PASSWORD.BUTTON' | translate}}</ion-label
        >
        <ion-input
          required
          type="text"
          name="password1"
          id="password"
          [(ngModel)]="model.password1"
          #password1="ngModel"
        ></ion-input>
      </ion-item>
      <div
        class="errortextpassword"
        [hidden]="password1.valid || password1.pristine"
      >
        {{'ERROR.LOGIN.REQUIRED' | translate}}
      </div>
      <ion-item>
        <ion-label stacked
          >{{'ACCOUNT.RESET_PASSWORD.CONFIRM_PASSWORD_LABEL' |
          translate}}</ion-label
        >
        <ion-input
          required
          type="text"
          name="password2"
          type="text"
          [(ngModel)]="model.password2"
          #password2="ngModel"
        ></ion-input>
      </ion-item>
      <div
        class="errortextpassword"
        [hidden]="password2.pristine || password1.value === password2.value"
      >
        {{'ACCOUNT_CREATION.LABELS.CONFIRMER_MOT_DE_PASSE' | translate}}
      </div>
      <div
        class="errortextpassword"
        [hidden]="password2.valid || password2.pristine"
      >
        {{'ERROR.LOGIN.REQUIRED' | translate}}
      </div>
      <button
        ion-button
        class="createuser"
        [disabled]="!resetForm.valid || (password1.value !== password2.value)"
      >
        {{'ACCOUNT.RESET_PARENT_PASSWORD.BUTTON' | translate}}
      </button>
    </form>
    <div *ngIf="!validToken">
      {{'ACCOUNT.RESET_PARENT_PASSWORD.INVALID_TOKEN' | translate}}
    </div>
  </div>
</ion-content>
<ion-footer>
  <app-bottom-menu></app-bottom-menu>
</ion-footer>
